import styled, { css, DefaultTheme } from 'styled-components';
export default styled.div`
  ${({ theme }: { theme: DefaultTheme }) => {
  return css`
    height: calc(100dvh - 6.25em);
    @media ${theme.mq.min.tablet} {
      height: calc(100dvh - 3em);
      max-height: 43.625em;
    }
  `;
  }}
`;
